export const company = {
  title: 'Locatie',
  type: 'checkbox',
  forceType: false,
  field: 'company',
  defaultOptionTitle: 'Alle locaties',
  hideWhenNoOptions: true,
  multiSelect: true,
  withCount: true,
};

export const size = {
  title: 'Grootte',
  type: 'sizes',
  forceType: true,
  field: 'size',
};

export const make = {
  title: 'Merk',
  type: 'checkbox',
  field: 'make',
  defaultOptionTitle: 'Alle merken',
  multiSelect: true,
};

export const model = {
  title: 'Model',
  type: 'checkbox',
  field: 'model',
  defaultOptionTitle: 'Alle modellen',
  hideWhenNoOptions: true,
  multiSelect: true,
};

export const priceMin = {
  title: 'Prijs',
  type: 'select',
  field: 'priceMin',
  defaultOptionTitle: 'Prijs vanaf',
  // use value string for isChecked value comparison
  options: [{
    name: '2.500',
    value: '2500',
  }, {
    name: '5.000',
    value: '5000',
  }, {
    name: '7.500',
    value: '7500',
  }, {
    name: '10.000',
    value: '10000',
  }, {
    name: '12.500',
    value: '12500',
  }, {
    name: '15.000',
    value: '15000',
  }, {
    name: '17.500',
    value: '17500',
  }, {
    name: '20.000',
    value: '20000',
  }, {
    name: '22.500',
    value: '22500',
  }, {
    name: '25.000',
    value: '25000',
  }, {
    name: '30.000',
    value: '30000',
  }, {
    name: '35.000',
    value: '35000',
  }, {
    name: '40.000',
    value: '40000',
  }, {
    name: '45.000',
    value: '45000',
  }, {
    name: '50.000',
    value: '50000',
  }, {
    name: '60.000',
    value: '60000',
  }, {
    name: '70.000',
    value: '70000',
  }, {
    name: '80.000',
    value: '80000',
  }, {
    name: '90.000',
    value: '90000',
  }, {
    name: '100.000',
    value: '100000',
  }],
};

export const priceMax = {
  type: 'select',
  field: 'priceMax',
  defaultOptionTitle: 'Prijs tot',
  // use value string for isChecked value comparison
  options: [{
    name: '2.500',
    value: '2500',
  }, {
    name: '5.000',
    value: '5000',
  }, {
    name: '7.500',
    value: '7500',
  }, {
    name: '10.000',
    value: '10000',
  }, {
    name: '12.500',
    value: '12500',
  }, {
    name: '15.000',
    value: '15000',
  }, {
    name: '17.500',
    value: '17500',
  }, {
    name: '20.000',
    value: '20000',
  }, {
    name: '22.500',
    value: '22500',
  }, {
    name: '25.000',
    value: '25000',
  }, {
    name: '30.000',
    value: '30000',
  }, {
    name: '35.000',
    value: '35000',
  }, {
    name: '40.000',
    value: '40000',
  }, {
    name: '45.000',
    value: '45000',
  }, {
    name: '50.000',
    value: '50000',
  }, {
    name: '60.000',
    value: '60000',
  }, {
    name: '70.000',
    value: '70000',
  }, {
    name: '80.000',
    value: '80000',
  }, {
    name: '90.000',
    value: '90000',
  }, {
    name: '100.000',
    value: '100000',
  }],
};

export const buildyear = {
  title: 'Bouwjaar',
  type: 'select',
  field: 'buildyear',
  defaultOptionTitle: 'Bouwjaar',
  hideWhenNoOptions: true,
};

export const buildyearMin = {
  title: 'Bouwjaar',
  type: 'select',
  field: 'buildyearMin',
  defaultOptionTitle: 'Bouwjaar vanaf',
  hideWhenNoOptions: true,
};

export const buildyearMax = {
  type: 'select',
  field: 'buildyearMax',
  defaultOptionTitle: 'Bouwjaar tot',
  hideWhenNoOptions: true,
};

export const odometerMin = {
  title: 'Tellerstand',
  type: 'select',
  field: 'odometerMin',
  defaultOptionTitle: 'Tellerstand vanaf',
  // use value string for isChecked value comparison
  options: [{
    name: '25.000',
    value: '25000',
  }, {
    name: '50.000',
    value: '50000',
  }, {
    name: '100.000',
    value: '100000',
  }, {
    name: '150.000',
    value: '150000',
  }, {
    name: '200.000',
    value: '200000',
  }, {
    name: '250.000',
    value: '250000',
  }],
};

export const odometerMax = {
  type: 'select',
  field: 'odometerMax',
  defaultOptionTitle: 'Tellerstand tot',
  // use value string for isChecked value comparison
  options: [{
    name: '10.000',
    value: '10000',
  }, {
    name: '25.000',
    value: '25000',
  }, {
    name: '50.000',
    value: '50000',
  }, {
    name: '100.000',
    value: '100000',
  }, {
    name: '150.000',
    value: '150000',
  }, {
    name: '200.000',
    value: '200000',
  }, {
    name: '250.000',
    value: '200000',
  }],
};

export const maxTowingMin = {
  title: 'Trekgewicht',
  type: 'select',
  field: 'maxTowingMin',
  defaultOptionTitle: 'Trekgewicht vanaf',
  hideWhenNoOptions: true,
};

export const maxTowingMax = {
  type: 'select',
  field: 'maxTowingMax',
  defaultOptionTitle: 'Trekgewicht tot',
  hideWhenNoOptions: true,
};

export const rangeMin = {
  title: 'Elektrische Actieradius',
  type: 'select',
  field: 'rangeMin',
  defaultOptionTitle: 'Actieradius vanaf',
  hideWhenNoOptions: true,
  options: [{
    name: '100 km',
    value: '100',
  }, {
    name: '200 km',
    value: '200',
  }, {
    name: '300 km',
    value: '300',
  }, {
    name: '400 km',
    value: '400',
  }, {
    name: '500 km',
    value: '500',
  }, {
    name: '600 km',
    value: '600',
  }, {
    name: '700 km',
    value: '700',
  }, {
    name: '800 km',
    value: '800',
  }, {
    name: '900 km',
    value: '900',
  }, {
    name: '1.000 km',
    value: '1000',
  }, {
    name: '1.250 km',
    value: '1250',
  }, {
    name: '1.500 km',
    value: '1500',
  }],
};

export const rangeMax = {
  type: 'select',
  field: 'rangeMax',
  defaultOptionTitle: 'Actieradius tot',
  hideWhenNoOptions: true,
  options: [{
    name: '1.500 km',
    value: '1500',
  }, {
    name: '1.250 km',
    value: '1250',
  }, {
    name: '1.000 km',
    value: '1000',
  }, {
    name: '900 km',
    value: '900',
  }, {
    name: '800 km',
    value: '800',
  }, {
    name: '700 km',
    value: '700',
  }, {
    name: '600 km',
    value: '600',
  }, {
    name: '500 km',
    value: '500',
  }, {
    name: '400 km',
    value: '400',
  }, {
    name: '300 km',
    value: '300',
  }, {
    name: '200 km',
    value: '200',
  }],
};

export const electricRangeMin = {
  title: 'Elektrische actieradius',
  type: 'select',
  field: 'electricRangeMin',
  defaultOptionTitle: 'Actieradius vanaf',
  hideWhenNoOptions: true,
  options: [{
    name: '25 km',
    value: '25',
  }, {
    name: '50 km',
    value: '50',
  }, {
    name: '75 km',
    value: '75',
  }, {
    name: '100 km',
    value: '100',
  }, {
    name: '150 km',
    value: '150',
  }, {
    name: '200 km',
    value: '200',
  }, {
    name: '300 km',
    value: '300',
  }, {
    name: '400 km',
    value: '400',
  }, {
    name: '500 km',
    value: '500',
  }, {
    name: '600 km',
    value: '600',
  }, {
    name: '700 km',
    value: '700',
  }],
};

export const electricRangeMax = {
  type: 'select',
  field: 'electricRangeMax',
  defaultOptionTitle: 'Actieradius tot',
  hideWhenNoOptions: true,
  options: [{
    name: '700 km',
    value: '700',
  }, {
    name: '600 km',
    value: '600',
  }, {
    name: '500 km',
    value: '500',
  }, {
    name: '400 km',
    value: '400',
  }, {
    name: '300 km',
    value: '300',
  }, {
    name: '200 km',
    value: '200',
  }, {
    name: '150 km',
    value: '150',
  }, {
    name: '100 km',
    value: '100',
  }, {
    name: '75 km',
    value: '75',
  }, {
    name: '50 km',
    value: '50',
  }, {
    name: '25 km',
    value: '25',
  }],
};

export const powerHpMin = {
  title: 'Vermogen',
  type: 'select',
  field: 'powerHpMin',
  defaultOptionTitle: 'Vermogen vanaf',
  hideWhenNoOptions: true,
  options: [{
    name: '50 PK',
    value: '50',
  }, {
    name: '70 PK',
    value: '70',
  }, {
    name: '90 PK',
    value: '90',
  }, {
    name: '100 PK',
    value: '100',
  }, {
    name: '110 PK',
    value: '110',
  }, {
    name: '125 PK',
    value: '125',
  }, {
    name: '150 PK',
    value: '150',
  }, {
    name: '200 PK',
    value: '200',
  }, {
    name: '250 PK',
    value: '250',
  }, {
    name: '300 PK',
    value: '300',
  }, {
    name: '400 PK',
    value: '400',
  }],
};

export const powerHpMax = {
  type: 'select',
  field: 'powerHpMax',
  defaultOptionTitle: 'Vermogen tot',
  hideWhenNoOptions: true,
  options: [{
    name: '400 PK',
    value: '400',
  }, {
    name: '300 PK',
    value: '300',
  }, {
    name: '250 PK',
    value: '250',
  }, {
    name: '200 PK',
    value: '200',
  }, {
    name: '150 PK',
    value: '150',
  }, {
    name: '125 PK',
    value: '125',
  }, {
    name: '110 PK',
    value: '110',
  }, {
    name: '100 PK',
    value: '100',
  }, {
    name: '90 PK',
    value: '90',
  }, {
    name: '70 PK',
    value: '70',
  }, {
    name: '50 PK',
    value: '25',
  }],
};

export const body = {
  type: 'checkbox',
  title: 'Carrosserie',
  field: 'body',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle carrosserieën',
  hideWhenNoOptions: true,
};

export const fuel = {
  type: 'checkbox',
  title: 'Brandstof',
  field: 'fuel',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle brandstoffen',
  hideWhenNoOptions: true,
};

export const transmission = {
  type: 'checkbox',
  title: 'Transmissie',
  field: 'transmission',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle transmissies',
  hideWhenNoOptions: true,
};

export const baseColor = {
  type: 'checkbox',
  title: 'Kleur',
  field: 'baseColor',
  defaultOptionTitle: 'Alle kleuren',
  withCount: true,
  multiSelect: true,
  hideWhenNoOptions: true,
};

export const energylabel = {
  type: 'energylabel',
  forceType: true,
  title: 'Energielabel',
  field: 'energylabel',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle energielabels',
  hideWhenNoOptions: true,
};

export const taxType = {
  type: 'checkbox',
  title: 'BTW/Marge',
  field: 'taxType',
  withCount: true,
  defaultOptionTitle: 'BTW of marge',
  hideWhenNoOptions: true,
};

export const vehicleType = {
  type: 'checkbox',
  title: 'Voertuigsoort',
  field: 'vehicleType',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle voertuigsoorten',
  hideWhenNoOptions: true,
};

export const isNewVehicle = {
  type: 'checkbox',
  multiSelect: false,
  title: 'Nieuw',
  field: 'isNewVehicle',
  withCount: true,
  defaultOptionTitle: 'Is een nieuw voertuig',
  hideWhenNoOptions: false,
  renameOptions: [{
    name: 'Ja',
    value: 'true',
  }, {
    name: 'Nee',
    value: 'false',
  }],
};
export const pluginHybrid = {
  type: 'checkbox',
  multiSelect: false,
  title: 'Plug-in hybride',
  field: 'pluginHybrid',
  withCount: true,
  defaultOptionTitle: 'Is een plug-in hybride?',
  hideWhenNoOptions: false,
  options: [{
    name: 'Ja',
    value: 'true',
  }, {
    name: 'Nee',
    value: 'false',
  }],
};

export const SRP = {
  type: 'select',
  multiSelect: false,
  title: 'Zoeken',
  field: 'srp',
  withCount: false,
  required: true,
  defaultOptionTitle: 'Overal zoeken',
};

export const srp = SRP;

export const leaseMin = {
  title: 'Maandbedrag',
  type: 'select',
  field: 'leaseMin',
  defaultOptionTitle: 'Maandbedrag vanaf',
  // use value string for isChecked value comparison
  options: [{
    name: '1 euro',
    value: '1',
  }, {
    name: '100',
  }, {
    name: '200',
  }, {
    name: '300',
  }, {
    name: '400',
  }, {
    name: '500',
  }, {
    name: '600',
  }, {
    name: '700',
  }, {
    name: '800',
  }, {
    name: '900',
  }],
};
export const leaseMax = {
  title: 'Maandbedrag maximaal',
  type: 'select',
  field: 'leaseMax',
  defaultOptionTitle: 'Maandbedrag tot',
  // use value string for isChecked value comparison
  options: [{
    name: '100',
  }, {
    name: '200',
  }, {
    name: '300',
  }, {
    name: '400',
  }, {
    name: '500',
  }, {
    name: '600',
  }, {
    name: '700',
  }, {
    name: '800',
  }, {
    name: '900',
  }, {
    name: '1.000',
    value: '1000',
  }],
};

export const externalLeaseMin = {
  ...leaseMin,
  field: 'externalLeaseMin',
};
export const externalLeaseMax = {
  ...leaseMax,
  field: 'externalLeaseMax',
};

export const privateLeaseMin = {
  ...leaseMin,
  field: 'privateLeaseMin',
};
export const privateLeaseMax = {
  ...leaseMax,
  field: 'privateLeaseMax',
};

export const doors = {
  type: 'checkbox',
  title: 'Deuren',
  field: 'doors',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle aantallen deuren',
  hideWhenNoOptions: false,
};
export const seats = {
  type: 'checkbox',
  title: 'Zitplaatsen',
  field: 'seats',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle aantallen zitplaatsen',
  hideWhenNoOptions: false,
};
export const taxAddition = {
  type: 'checkbox',
  title: 'Bijtelling',
  field: 'taxAddition',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle bijtellingen',
  hideWhenNoOptions: false,
};
export const range = {
  type: 'checkbox',
  title: 'Actieradius',
  field: 'range',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle actieradiussen',
  hideWhenNoOptions: false,
};
export const electricRange = {
  type: 'checkbox',
  title: 'Actieradius elektrisch',
  field: 'electricRange',
  withCount: true,
  multiSelect: true,
  defaultOptionTitle: 'Alle actieradiussen',
  hideWhenNoOptions: false,
};
